import React from "react";
import { Dialog } from "../../../components/Dialogs/Dialog";
import { IActionItem } from "../../../redux/actionItems/actionItem.types";
import { Grid } from "@mui/material";
import { UsersAutoSearch } from "../../../components/AutoCompleteSearches/UsersAutoSearch";
import { useDispatchWrapper } from "../../../hooks";
import { upsertActionItemAsync } from "../../../redux/actionItems";
import { IUser } from "../../../components/AutoCompleteSearches/AutoCompleteSearches.types";
import { showMessage } from "../../../redux/messages/messagesActions";

interface IAssignChatLeadDialogProps {
  open: boolean;
  onClose: () => void;
  actionItem: IActionItem;
}
export const AssignChatLeadDialog: React.FC<IAssignChatLeadDialogProps> = (
  props,
) => {
  const { open, onClose, actionItem } = props;

  const dispatch = useDispatchWrapper();

  const [selectedUser, setSelectedUser] = React.useState<IUser | null>(null);

  const handleAssignChatLead = () => {
    if (selectedUser) {
      dispatch(
        upsertActionItemAsync(
          {
            ...actionItem,
            assigned_to_name:
              selectedUser.user_name || selectedUser.full_name || "",
            assigned_to_uuid: selectedUser?.user_uuid || "",
          },
          (isSuccess) => {
            if (isSuccess) {
              onClose();
            }
          },
        ),
      );
    } else {
      dispatch(
        showMessage({
          type: "error",
          message: "Please select a user",
          displayAs: "snackbar",
        }),
      );
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Handled By Employee"
      size="sm"
      actions={[
        {
          label: "Assign",
          variant: "contained",
          onClick: handleAssignChatLead,
          type: "button",
        },
      ]}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <UsersAutoSearch
            label="Select Handled By Employee"
            showTopLabel={false}
            value={{
              user_uuid: selectedUser?.user_uuid || "",
              user_name: selectedUser?.full_name || "",
            }}
            onSelect={(newValue: any) => {
              setSelectedUser(newValue);
            }}
          />
        </Grid>
      </Grid>
    </Dialog>
  );
};
